import type { DriverEmployee } from './vehicle/vehicle-driver.model';
/** A single GPS reading attached to a vehicle state. */
export interface Reading {
  altitude: number;
  datetime: string;
  heading: number;
  id: number;
  movementType: number;
  point: {
    type: string;
    coordinates: [number, number];
  };
  speed: number;
}

export enum VehicleStateType {
  traveling = 'traveling',
  idling = 'idling',
  stopped = 'stopped',
  user = 'user',
  marker = 'marker-preview',
  towed = 'towed',
  error = 'error',
  nonTracker = 'non-tracker',
}

export interface VehicleState {
  layout: any;
  id: number;
  type: VehicleStateType;
  created: Date;
  modified: Date;
  distance: number;
  duration: {
    lower: any;
    upper: any;
  };
  vehicle: number;
  description: string;
  detailUrl: string;
  locations?: { start: string; end: string };
  point?: { type: string; coordinates: number[] };
  reading?: Reading;
  drivers?: DriverEmployee[];
}

/**
 * End of a state's duration in epoch milliseconds. Ongoing states (a trip
 * still in progress) arrive with `duration.upper` null — treat them as
 * running until "now" rather than `new Date(null)` (epoch 0), which made
 * in-progress states vanish from the day timelines.
 */
export function getStateEndTime(state: Pick<VehicleState, 'duration'>): number {
  const upper = state.duration?.upper;
  return upper ? new Date(upper).getTime() : Date.now();
}

export interface BaseState {
  created: Date;
  detailUrl: string;
  duration: { lower: Date; upper: Date };
  id: number;
  modified: Date;
  project: any;
  type: VehicleStateType;
  vehicle: number;
}
